// extracted by mini-css-extract-plugin
module.exports = {"checkBoxContainer":"checkBox_checkBoxContainer__eFKLU","checkmark":"checkBox_checkmark__Od_8j","arrow":"checkBox_arrow__jHt9M"};